import React, { useContext } from "react";
import ReactMapGL from "react-map-gl";
import { MapContext } from "./MapContext";

export default function Map({ children, ...props }) {
  const { viewState, setViewStateInBounds, mapRef } = useContext(MapContext);
  return (
    <ReactMapGL
      {...viewState}
      ref={ref => (mapRef.current = ref && ref.getMap())}
      onViewportChange={viewport => setViewStateInBounds(viewport)}
      {...props}
    >
      {children}
    </ReactMapGL>
  );
}
